module.exports = __webpack_public_path__ + "img/Det-norske-folkesprogs-grammatik_Bilde-av-boken-under-Dialekt--og-ordsamler.ab2f7556.jpg";